const bannerFlag = [
  {
    code: "GBP", // UK
    countryFlag:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754986445/emojione_flag-for-united-kingdom_bcbadx.png",
    countryIcon:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754986447/image_98_iagzlf.pn",
    width: "671",
    height: "1021",
    // top: "12%",
    // right: "0",
    fiting: "banner-country-UK",
  },
  {
    code: "NGN", // Nigeria
    countryFlag:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1753054577/emojione_flag-for-nigeria_j9eafy.png",
    countryIcon:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1753054578/image_131_1_mygzca.png",
    width: "1722",
    height: "1148",
    top: "-5%",
    right: "-60%",
    fiting: "banner-country-NG",
  },
  {
    code: "GHS", // Ghana
    countryFlag:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1753054837/emojione_flag-for-ghana_dkgza8.png",
    countryIcon:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1753054838/image_132_1_ihkclg.png",
    width: "896",
    height: "929",
    top: "12%",
    right: "-25%",
    fiting: "banner-country-GH",
  },
  {
    code: "KES", // Kenya
    countryFlag:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1753032854/emojione_flag-for-kenya_ahfqwo.png",
    countryIcon: "",
    fiting: "",
  },
  {
    code: "USD", // United States
    countryFlag:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754986447/image_98_iagzlf.png",
    countryIcon: "",
    fiting: "",
  },
  {
    code: "EUR", // France/Eurozone
    countryFlag:
      "https://res.cloudinary.com/dpkn1ppzj/image/upload/v1754986447/image_98_iagzlf.png",
    countryIcon: "",
    fiting: "",
  },
  // ...add more as needed
];

export default bannerFlag;
